import {createBrowserHistory} from 'history';

export const browserHistory = createBrowserHistory({window});

export function redirectTo(url: string): void {
    browserHistory.push(url);
}
